import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LumpSumPaymentInstruction } from '../../../../../../models/transactions/lump-sum-payment-instruction';

@Component({
  selector: 'app-vb-payment-change-lump-sum-upcoming-card',
  templateUrl: './vb-payment-change-lump-sum-upcoming-card.component.html',
  styleUrls: ['./vb-payment-change-lump-sum-upcoming-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeLumpSumUpcomingCardComponent {
  @Input({ required: true }) lumpSumPayment!: LumpSumPaymentInstruction;
}
